import React from 'react'
import useAOS from '../shared/useAos';

export default function Banner2() {
    useAOS();
    return (
        <section
        className="bg-banner3 bg-blend-soft-light bg-buttonHover opacity-80 bg-cover bg-center bg-no-repeat min-h-[500px]">
        <div 
        data-aos="fade-left"
        data-aos-delay="300"
        data-aos-duration="600"    
        className="p-14 md:p-12 lg:px-16 lg:py-24">
            <div className="text-center ltr:sm:text-left rtl:sm:text-right">
            <h2 className="text-2xl mt-10 lg:mt-auto text-left font-bold text-white sm:text-3xl md:text-5xl">Transform Your Vision into Reality with Arcium Studio</h2>

            <p className="w-full md:w-3/4 mt-10 text-lg lg:text-base lg:mt-5 text-left text-color1 md:mt-6 md:block md:text-lg md:leading-relaxed">
            At Arcium Studio, we go beyond building structures—we craft spaces that inspire and function beautifully. Whether it’s a new home, renovation, or commercial project, our team ensures innovation, sustainability, and precision in every detail. Book a Consultation Ready to bring your vision to life? Schedule a meeting with us—online or in person—and let’s create something extraordinary together.          
            </p>

            </div>
            <div className="lg:mt-5 mt-14 mb-10 lg:mb-auto">
                <a
                href="/contact"
                className="text-left text-color1 bg-hover hover:bg-buttonHover inline-block rounded-full bg-indigo-600 px-12 py-5 lg:py-3 text-md font-medium text-white transition hover:bg-indigo-700 focus:ring-3 focus:ring-yellow-400 focus:outline-hidden"
                >
                Book Now
                </a>

            </div>

        </div>
        </section>
    )
}
